import React from 'react';
import './BouquetsPage.css';
import {useBouquets, BouquetsList} from "../../features/bouquets";
import {useSEO} from "../../shared/ui/SEOHead";

export const BouquetsPage: React.FC = () => {
    useSEO({
        title: "Каталог букетов и цветов — доставка в Булгаково и Уфе | «Ваниль»",
        description: "Купить авторские и свежие букеты цветов с доставкой по Уфе и селу Булгаково. Большой выбор, удобный заказ, честные цены.",
        canonicalUrl: "https://vanilufa.ru/bouquets"
    });

    const {loading, bouquets, error, getBouquets } = useBouquets()

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Загрузка букетов...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                ERRROORRRR
                <p className="error-message">{error}</p>
                <button onClick={getBouquets} className="retry-button">
                    Попробовать снова
                </button>
            </div>
        );
    }

    // BreadcrumbList schema
    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Главная", "item": "https://vanilufa.ru/" },
            { "@type": "ListItem", "position": 2, "name": "Каталог букетов", "item": "https://vanilufa.ru/bouquets" }
        ]
    };

    // ItemList schema for the bouquet grid
    const itemListSchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "Каталог букетов «Ваниль»",
        "description": "Свежие букеты с доставкой по Уфе и Булгаково",
        "numberOfItems": bouquets.length,
        "itemListElement": bouquets.map((bouquet, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "url": `https://vanilufa.ru/bouquets/${bouquet.id}`,
            "name": bouquet.name
        }))
    };

    return (
        <div className="bouquet-showcase">
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListSchema) }}
            />
            <div className="showcase-header">
                <h2>Купить цветы и букеты в Булгаково и Уфе</h2>
                <p>Подборка букетов из цветочного магазина «Ваниль» в Булгаково и Уфе. Выберите готовый вариант или соберите букет под заказ.</p>
            </div>

            {!bouquets.length ? (
                <div className="empty-state">
                    <p>Букеты не найдены</p>
                    <button onClick={getBouquets} className="sync-button">
                        Повторить
                    </button>
                </div>
            ) : (
                <BouquetsList {...bouquets} />
            )}
        </div>
    );
};